import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { components } from 'react-select';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
export { ClearIndicator, DropdownIndicator, LoadingIndicator } from './indicators';
var disabledProps = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n"])));
var enabledProps = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inherit;\n"])));
export var MultiValueRemove = function MultiValueRemove(props) {
  var isDisabled = props.selectProps.isDisabled;
  return jsx(components.MultiValueRemove, props, jsx("div", {
    css: isDisabled ? disabledProps : enabledProps,
    "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
  }, jsx(SelectClearIcon, {
    label: "Clear",
    size: "small",
    primaryColor: "transparent",
    secondaryColor: "inherit"
  })));
};
export var IndicatorSeparator = null;